<script>
import gql from "graphql-tag";
import { tournamentMatchFragment } from "@/graphql/tournament";
import { DialogInputTypes } from "@/js/helper";
import GenerateKODrawDialog from "./generateKODrawDialog.vue";

export default {
  name: "GenerateFriendlyKODrawDialog",
  extends: GenerateKODrawDialog,
  computed: {
    title: {
      get() {
        return "Generate Friendly KO Draw";
      }
    },
    instructions: {
      get() {
        return "Generate a traditional binary-tree format with consolations flights similar to the 'Knockout' format except that Byes do NOT count as matches played.";
      }
    }
  },
  methods: {
    submit() {
      return this.$apollo
        .mutate({
          mutation: gql`
            mutation(
              $tournamentId: ID!
              $knockoutOptions: KnockoutFormatOptions!
            ) {
              generateFriendlyKnockoutDraw(
                tournamentId: $tournamentId
                knockoutOptions: $knockoutOptions
              ) {
                ...TournamentMatch
              }
            }
            ${tournamentMatchFragment}
          `,
          variables: {
            tournamentId: this.tournament.id,
            knockoutOptions: {
              numberOfConselationFlights: this.nConsolationFlights.value,
              seeds: this.nSeeds.value
            }
          }
        })
        .then(result => {
          this.$root.$emit("updateTournament", this.tournament.id);
          this.$store.commit("setNotification", `Generated Friendly KO draw`);
        })
        .catch(err => {
          console.log(err);
          window.alert("Failed to generate Friendly KO draw");
        });
    }
  }
};
</script>


// WEBPACK FOOTER //
// generateFriendlyKODrawDialog.vue?aedfb1b6